import React, { useEffect, useRef, useCallback } from "react";
import styles from "./GalleryImages.module.css";
import { GalleryImage } from "../ImagesDisplay/GalleryImage";

interface GalleryImagesProps {
  slides: GalleryImage[];
  onImageClick: (idx: number) => void;
}

const GalleryImages: React.FC<GalleryImagesProps> = ({
  slides,
  onImageClick,
}) => {
  const imageRefs = useRef<(HTMLImageElement | null)[]>([]);

  const setImageRef = useCallback(
    (el: HTMLImageElement | null, idx: number) => {
      imageRefs.current[idx] = el;
    },
    []
  );

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          img.src = img.dataset.src!;
          observer.unobserve(img);
        }
      });
    });

    imageRefs.current.forEach((img) => {
      if (img) {
        observer.observe(img);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={styles.grid}>
      {slides.map((image, idx) => (
        <div
          key={idx}
          className={styles.imageWrapper}
          onClick={() => onImageClick(idx)}
        >
          <img
            ref={(el) => setImageRef(el, idx)}
            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            data-src={image.src}
            alt={image.description}
            className={styles.image}
          />
          {/* <div className={styles.caption}>
            <span>{image.description}</span>
          </div> */}
        </div>
      ))}
    </div>
  );
};

export default GalleryImages;
